import { Box, Button, styled, Typography } from "@mui/material";
import { colors } from "../Theme/ColorsForTheam";
import { useAppDispatch } from "../store";
import { userLogOut } from "../store/Auth/thunks";
import { useTranslation } from "react-i18next";
import { unauthorizedHandler } from "../store/Auth/authStore";

const WindowContainer = styled(Box)({
  position: "fixed",
  top: "0px",
  bottom: "0px",
  left: "0px",
  right: "0px",
  background: "var(--g-overlay)",
  width: "100vw",
  height: "100vh",
  zIndex: 1000,
});

const LogOutBox = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  padding: "24px",
  borderRadius: "22px",
  background: "var(--g-surface)",
  border: "1px solid var(--g-border)",
  boxShadow: "var(--g-shadow-lg)",
  minWidth: "650px",
});
interface UnauthorizedProps {
  message: string;
}
export const Unauthorized = (props: UnauthorizedProps) => {
  const { message } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  return (
    <WindowContainer>
      <LogOutBox>
        <Typography variant="h1" textAlign={"center"}>
          Unauthorized
        </Typography>
        <Typography
          variant="body1"
          color={colors.red[600]}
          textAlign={"center"}
          sx={{ marginTop: 1.5 }}
        >
          {message}
        </Typography>
        <Box sx={{ width: "50%", margin: "32px auto 0px auto" }}>
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              dispatch(
                unauthorizedHandler({ code: 0, message: "", status: false })
              );
              dispatch(userLogOut());
            }}
            sx={{
              boxShadow: "none",
              "&:hover, &:focus": {
                boxShadow: "none",
              },
            }}
          >
            {t("Header.logout")}
          </Button>
        </Box>
      </LogOutBox>
    </WindowContainer>
  );
};
